<mat-card [attr.role]="selectionType" [attr.aria-checked]="isSelected" tabindex="0" matRipple
  [matRippleColor]="rippleColor" class="wizard-tile-wrapper"
  [ngClass]="{ 'tileSelected' : isSelected, 'is-full-width-tile': isSingleOption, 'radio-tile': isRadioTile, 'checkbox-tile': isCheckboxTile, 'brand-tile': isBrandsStep, 'wide': currentStepName.trim() === 'Need to Run Step', 'overrideLength': overrideLength }"
  (click)="onTileSelected($event)" (keydown.enter)="onTileSelected($event)" (keydown.space)="onTileSelected($event)">

  <div class="wizard-tile-contents">
    <div class="wizard-tile-top" *ngIf="currentStepName.trim() !== 'Need to Run Step' && (wizardOption.iconName !== '' || wizardOption.imgSrc !== '')"
    [ngClass]="{ 'wizard-tile-top-color-override' : overrideTileTopColor}">
      <div class="wizard-column">
        <span class="wizard-tile-icon-wrapper" *ngIf="
          currentStepName.trim() !== 'Brand Step'
        ">
          <img class="wizard-tile-icon--svg" src="../../../assets/images/{{wizardOption.iconName}}"/>
        </span>
        <span class="wizard-tile-icon-wrapper" *ngIf="currentStepName.trim() === 'Brand Step'">
          <mat-icon class="wizard-tile-icon" [ngClass]="{'wizard-tile-icon--svg': wizardOption.iconSvgName}"
            *ngIf="wizardOption.iconFontSet && wizardOption.iconName || wizardOption.iconSvgName"
            [fontSet]="wizardOption.iconFontSet" [fontIcon]="wizardOption.iconName"
            [svgIcon]="wizardOption.iconSvgName"></mat-icon>
        </span>

        <span class="mobile-checkbox-selected-icon-wrapper">
          <mat-icon class="unselected-icon" fontSet="far" fontIcon="fa-square"></mat-icon>
          <mat-icon class="selected-icon" fontSet="fas" fontIcon="fa-check-square"></mat-icon>
        </span>

        <img class="wizard-tile-image tile-top-image" *ngIf="wizardOption.imgSrc" [src]="wizardOption.imgSrc"
          [attr.alt]="wizardOption.title" [attr.aria-hidden]="true" />
      </div>
    </div>

    <div class="wizard-tile-bottom"
      [ngClass]="{ 'isAlignLeft' : isAlignTextLeft, 'noBottomPadding': removeBottomPadding, 'singleTitle': !wizardOption.subtitle, 'full-height': wizardOption.subtitle && currentStepName.trim() === 'Need to Run Step', 'tile-bottom-padding-override': currentStepName.trim() === 'Primary Use Step'}"
      *ngIf="displayTitle && (wizardOption.title !== '' || wizardOption.subtitle !== '')">
      <div class="column">
        <mat-card-title class="wizard-tile-title" [ngClass]="{'title-with-icon': hasIconByTitle}">
          <span class="title-icon-wrapper" *ngIf="
          hasIconByTitle
        ">
          <img class="title-icon" src="../../../assets/images/{{wizardOption.iconName}}"/>
        </span>
          <span class="title" >{{wizardOption.title}}</span>
          <span class="mobile-radio-selected-icon-wrapper">
            <mat-icon class="selected-icon" fontSet="fas" fontIcon="fa-check-circle"></mat-icon>
          </span>
        </mat-card-title>
        <mat-card-subtitle class="wizard-tile-subtitle isAlignLeft"
          *ngIf="wizardOption.subtitle !== '' && (currentStepName.trim() !== 'Need to Run Step' || currentStepName.trim() === 'Need to Run Step' && isEducation)">
          {{wizardOption.subtitle}}

          <div class="wizard-tile-list" *ngIf="wizardOption.title === 'Learning Anywhere' ">
            <div class="wizard-tile-pill">
              <svg class="wizard-tile-pill-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_431_510)">
                  <path
                    d="M14.59 2.59C14.21 2.21 13.7 2 13.17 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8.83C20 8.3 19.79 7.79 19.41 7.42L14.59 2.59ZM15 18H9C8.45 18 8 17.55 8 17C8 16.45 8.45 16 9 16H15C15.55 16 16 16.45 16 17C16 17.55 15.55 18 15 18ZM15 14H9C8.45 14 8 13.55 8 13C8 12.45 8.45 12 9 12H15C15.55 12 16 12.45 16 13C16 13.55 15.55 14 15 14ZM13 8V3.5L18.5 9H14C13.45 9 13 8.55 13 8Z" />
                </g>
                <defs>
                  <clipPath id="clip0_431_510">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              {{confSvc.getString("needToRunEntSimpleBulletOne")}}
            </div>

            <div class="wizard-tile-pill">
              <svg class="wizard-tile-pill-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM4 9H14.5V12.5H4V9ZM4 14.5H14.5V18H5C4.45 18 4 17.55 4 17V14.5ZM19 18H16.5V9H20V17C20 17.55 19.55 18 19 18Z" />
              </svg>
              {{confSvc.getString("needToRunEduSimpleBullet")}}
            </div>

            <div class="wizard-tile-pill icon-three">
              <svg class="wizard-tile-pill-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L19.29 15.79C19.92 16.42 21 15.97 21 15.08V8.91C21 8.02 19.92 7.57 19.29 8.2L17 10.5Z" />
              </svg>
              {{confSvc.getString("needToRunEntSimpleBulletThree")}}
            </div>
          </div>

          <div class="wizard-tile-list" *ngIf="wizardOption.title === 'Advanced Use' ">
            <div class="wizard-tile-pill">
              <svg class="wizard-tile-pill-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_404_323)">
                  <path
                    d="M18.85 10.39L19.91 9.33C20.69 8.55 20.69 7.28 19.91 6.5L18.5 5.09C17.72 4.31 16.45 4.31 15.67 5.09L14.61 6.15L18.85 10.39ZM13.19 7.56L4.14 16.61C4.05 16.7 4 16.83 4 16.96V20.5C4 20.78 4.22 21 4.5 21H8.04C8.17 21 8.3 20.95 8.39 20.85L17.44 11.8L13.19 7.56ZM19 17.5C19 19.69 16.46 21 14 21C13.45 21 13 20.55 13 20C13 19.45 13.45 19 14 19C15.54 19 17 18.27 17 17.5C17 17.03 16.52 16.63 15.77 16.3L17.25 14.82C18.32 15.45 19 16.29 19 17.5ZM4.58 13.35C3.61 12.79 3 12.06 3 11C3 9.2 4.89 8.37 6.56 7.64C7.59 7.18 9 6.56 9 6C9 5.59 8.22 5 7 5C5.74 5 5.2 5.61 5.17 5.64C4.82 6.05 4.19 6.1 3.77 5.76C3.36 5.42 3.28 4.81 3.62 4.38C3.73 4.24 4.76 3 7 3C9.24 3 11 4.32 11 6C11 7.87 9.07 8.72 7.36 9.47C6.42 9.88 5 10.5 5 11C5 11.31 5.43 11.6 6.07 11.86L4.58 13.35Z" />
                </g>
                <defs>
                  <clipPath id="clip0_404_323">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <!-- Content creation-->
              {{ confSvc.getString("needToRunEduAdvBulletOne")}}
            </div>

            <div class="wizard-tile-pill">
              <svg class="wizard-tile-pill-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_404_299)">
                  <g clip-path="url(#clip1_404_299)">
                    <path
                      d="M9.4 16.6L4.8 12L9.4 7.4L8 6L2 12L8 18L9.4 16.6ZM14.6 16.6L19.2 12L14.6 7.4L16 6L22 12L16 18L14.6 16.6Z" />
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_404_299">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                  <clipPath id="clip1_404_299">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <!-- Coding -->
              {{ confSvc.getString("needToRunEduAdvBulletTwo")}}
            </div>

            <div class="wizard-tile-pill">
              <svg class="wizard-tile-pill-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_382_402)">
                  <path
                    d="M18.0002 13H12.9402C12.6002 16.1 10.6802 18.72 8.00016 20.05C7.97016 21.86 6.34016 23.28 4.45016 22.95C3.25016 22.74 2.26016 21.75 2.05016 20.55C1.71016 18.65 3.16016 17 5.00016 17C5.95016 17 6.78016 17.45 7.33016 18.14C9.23016 17.11 10.5902 15.23 10.9102 13H7.81016C7.33016 14.34 5.95016 15.24 4.39016 14.94C3.21016 14.71 2.26016 13.74 2.04016 12.56C1.70016 10.66 3.16016 9 5.00016 9C6.30016 9 7.40016 9.84 7.82016 11H10.9202C10.6002 8.77 9.23016 6.9 7.33016 5.86C6.69016 6.66 5.66016 7.14 4.52016 6.96C3.29016 6.77 2.26016 5.77 2.05016 4.54C1.72016 2.65 3.17016 1 5.00016 1C6.64016 1 7.96016 2.31 7.99016 3.95C10.6702 5.28 12.5902 7.9 12.9302 11H18.0002V9.21C18.0002 8.76 18.5402 8.54 18.8502 8.86L21.6402 11.65C21.8402 11.85 21.8402 12.16 21.6402 12.36L18.8502 15.15C18.5402 15.46 18.0002 15.24 18.0002 14.79V13Z" />
                </g>
                <defs>
                  <clipPath id="clip0_382_402">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <!-- Virutalization -->
              {{ confSvc.getString("needToRunEntAdvBulletThree")}}
            </div>

            <div class="wizard-tile-pill">
              <svg class="wizard-tile-pill-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_404_314)">
                  <path
                    d="M17 5V21C17 21.55 16.55 22 16 22H8C7.45 22 7 21.55 7 21V5C7 4.45 7.45 4 8 4H10V3C10 2.45 10.45 2 11 2H13C13.55 2 14 2.45 14 3V4H16C16.55 4 17 4.45 17 5ZM15 6H9V8H15V6Z" />
                </g>
                <defs>
                  <clipPath id="clip0_404_314">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <!-- Heavy multitasking -->
              {{ confSvc.getString("needToRunEduAdvBulletThree")}}
            </div>

            <div class="wizard-tile-pill">
              <svg class="wizard-tile-pill-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_404_291)">
                  <g clip-path="url(#clip1_404_291)">
                    <path
                      d="M21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 22.99 18.1 22.99 17L23 5C23 3.9 22.1 3 21 3ZM21 17H3V5H21V17Z" />
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_404_291">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                  <clipPath id="clip1_404_291">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <!-- external monitors -->
              {{ confSvc.getString("needToRunEduAdvBulletFour")}}
            </div>
          </div>

        </mat-card-subtitle>

        <mat-card-subtitle class="wizard-tile-subtitle isAlignLeft"
          *ngIf="wizardOption.subtitle && currentStepName.trim() === 'Need to Run Step' && !isEducation">
          <div>
            <span>
              {{wizardOption.subtitle}}
            </span>

            <div class="wizard-tile-list" *ngIf="wizardOption.title === 'Standard Workload' ">
              <div class="wizard-tile-pill">
                <svg class="wizard-tile-pill-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_431_510)">
                    <path
                      d="M14.59 2.59C14.21 2.21 13.7 2 13.17 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8.83C20 8.3 19.79 7.79 19.41 7.42L14.59 2.59ZM15 18H9C8.45 18 8 17.55 8 17C8 16.45 8.45 16 9 16H15C15.55 16 16 16.45 16 17C16 17.55 15.55 18 15 18ZM15 14H9C8.45 14 8 13.55 8 13C8 12.45 8.45 12 9 12H15C15.55 12 16 12.45 16 13C16 13.55 15.55 14 15 14ZM13 8V3.5L18.5 9H14C13.45 9 13 8.55 13 8Z" />
                  </g>
                  <defs>
                    <clipPath id="clip0_431_510">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                {{confSvc.getString("needToRunEntSimpleBulletOne")}}
              </div>
              <div class="wizard-tile-pill">
                <svg class="wizard-tile-pill-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_431_486)">
                    <path
                      d="M5 11H9C10.1 11 11 10.1 11 9V5C11 3.9 10.1 3 9 3H5C3.9 3 3 3.9 3 5V9C3 10.1 3.9 11 5 11Z" />
                    <path
                      d="M5 21H9C10.1 21 11 20.1 11 19V15C11 13.9 10.1 13 9 13H5C3.9 13 3 13.9 3 15V19C3 20.1 3.9 21 5 21Z" />
                    <path
                      d="M13 5V9C13 10.1 13.9 11 15 11H19C20.1 11 21 10.1 21 9V5C21 3.9 20.1 3 19 3H15C13.9 3 13 3.9 13 5Z" />
                    <path
                      d="M15 21H19C20.1 21 21 20.1 21 19V15C21 13.9 20.1 13 19 13H15C13.9 13 13 13.9 13 15V19C13 20.1 13.9 21 15 21Z" />
                  </g>
                  <defs>
                    <clipPath id="clip0_431_486">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                {{ confSvc.getString("needToRunEntAdvBulletTwo")}}
              </div>


              <div class="wizard-tile-pill">
                <svg class="wizard-tile-pill-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM4 9H14.5V12.5H4V9ZM4 14.5H14.5V18H5C4.45 18 4 17.55 4 17V14.5ZM19 18H16.5V9H20V17C20 17.55 19.55 18 19 18Z" />
                </svg>
                {{confSvc.getString("needToRunEntSimpleBulletTwo")}}
              </div>

              <div class="wizard-tile-pill icon-three">
                <svg class="wizard-tile-pill-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L19.29 15.79C19.92 16.42 21 15.97 21 15.08V8.91C21 8.02 19.92 7.57 19.29 8.2L17 10.5Z" />
                </svg>
                {{confSvc.getString("needToRunEntSimpleBulletThree")}}
              </div>
            </div>

            <div class="wizard-tile-list" *ngIf="wizardOption.title === 'Advanced Workload' ">
              <div class="wizard-tile-pill">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                  class="wizard-tile-pill-icon">
                  <g clip-path="url(#clip0_382_393)">
                    <path
                      d="M12 7V5C12 3.9 11.1 3 10 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V9C22 7.9 21.1 7 20 7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM19 19H12V17H14V15H12V13H14V11H12V9H19C19.55 9 20 9.45 20 10V18C20 18.55 19.55 19 19 19ZM18 11H16V13H18V11ZM18 15H16V17H18V15Z" />
                  </g>
                  <defs>
                    <clipPath id="clip0_382_393">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                {{ confSvc.getString("needToRunEntAdvBulletOne")}}
              </div>

              <div class="wizard-tile-pill">
                <svg class="wizard-tile-pill-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_382_402)">
                    <path
                      d="M18.0002 13H12.9402C12.6002 16.1 10.6802 18.72 8.00016 20.05C7.97016 21.86 6.34016 23.28 4.45016 22.95C3.25016 22.74 2.26016 21.75 2.05016 20.55C1.71016 18.65 3.16016 17 5.00016 17C5.95016 17 6.78016 17.45 7.33016 18.14C9.23016 17.11 10.5902 15.23 10.9102 13H7.81016C7.33016 14.34 5.95016 15.24 4.39016 14.94C3.21016 14.71 2.26016 13.74 2.04016 12.56C1.70016 10.66 3.16016 9 5.00016 9C6.30016 9 7.40016 9.84 7.82016 11H10.9202C10.6002 8.77 9.23016 6.9 7.33016 5.86C6.69016 6.66 5.66016 7.14 4.52016 6.96C3.29016 6.77 2.26016 5.77 2.05016 4.54C1.72016 2.65 3.17016 1 5.00016 1C6.64016 1 7.96016 2.31 7.99016 3.95C10.6702 5.28 12.5902 7.9 12.9302 11H18.0002V9.21C18.0002 8.76 18.5402 8.54 18.8502 8.86L21.6402 11.65C21.8402 11.85 21.8402 12.16 21.6402 12.36L18.8502 15.15C18.5402 15.46 18.0002 15.24 18.0002 14.79V13Z" />
                  </g>
                  <defs>
                    <clipPath id="clip0_382_402">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                {{ confSvc.getString("needToRunEntAdvBulletThree")}}
              </div>
              <div class="wizard-tile-pill">
                <svg class="wizard-tile-pill-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_426_13)">
                    <path
                      d="M18.5582 2H9.68733C7.77778 2.00022 6.24911 3.54822 6.24556 5.44178V6.24444H5.44289C3.54111 6.24467 2.00067 7.78533 2 9.68733V18.5569C2.00067 20.4587 3.54089 21.9993 5.44289 22H14.3116C16.2133 21.9993 17.7538 20.4587 17.7544 18.5569V17.7556H18.5582C20.4518 17.7524 21.9993 16.2231 22 14.3138V5.44178C21.9969 3.54244 20.4576 2.00289 18.5582 2ZM15.9367 18.5569C15.9351 19.454 15.2087 20.1804 14.3118 20.1822H5.44289C4.54578 20.1804 3.81956 19.454 3.81778 18.5569V9.68733C3.81933 8.78978 4.54556 8.06378 5.44289 8.062H14.3116C15.2087 8.06378 15.9349 8.79 15.9364 9.68733L15.9367 18.5569ZM20.1822 14.3138C20.1807 15.2158 19.452 15.9376 18.5582 15.938H17.7544V9.68733C17.7538 7.78533 16.2133 6.24467 14.3116 6.24444H8.06333V5.442C8.06356 4.548 8.78533 3.81956 9.68733 3.81778H18.5582C19.0047 3.818 19.4062 3.99867 19.7047 4.29556C20.0018 4.59378 20.182 4.99533 20.1822 5.44178V14.3138Z" />
                  </g>
                  <defs>
                    <clipPath id="clip0_426_13">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                {{ confSvc.getString("needToRunEntAdvBulletFour")}}
              </div>

              <div class="wizard-tile-pill">
                <svg class="wizard-tile-pill-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_426_2)">
                    <path
                      d="M17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V7L17 3ZM12 19C10.34 19 9 17.66 9 16C9 14.34 10.34 13 12 13C13.66 13 15 14.34 15 16C15 17.66 13.66 19 12 19ZM15 9H5V5H15V9Z" />
                  </g>
                  <defs>
                    <clipPath id="clip0_426_2">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                {{ confSvc.getString("needToRunEntAdvBulletFive")}}
              </div>
            </div>
          </div>
        </mat-card-subtitle>

        <div class="mobile-brand-image-wrapper">
          <div>
            <img class="wizard-tile-image tile-bottom-image" *ngIf="wizardOption.imgSrc" [src]="wizardOption.imgSrc"
              [attr.alt]="wizardOption.title" [attr.aria-hidden]="true" />

            <span *ngIf="!wizardOption.imgSrc">
              <mat-icon class="wizard-tile-icon tile-bottom-image"
                *ngIf="wizardOption.iconFontSet && wizardOption.iconName" [fontSet]="wizardOption.iconFontSet"
                [fontIcon]="wizardOption.iconName"></mat-icon>
            </span>
          </div>
          <div>
            <mat-card-title class="mobile-brand-title"
              *ngIf="wizardOption.title">{{wizardOption.title}}</mat-card-title>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-card>
